<template>
  <app-report
    id="CidadesCreate"
    v-if="balancete"
  >
    <app-widget flat>
      <div slot="widget-content">
        <v-row>
          <v-col cols="6">
            <div>
              <v-subheader
                class="subtitle-1 font-weight-bold accent--text"
                v-text="`Descrição da visita`"
              />
            </div>
            <v-simple-table :dense="tableDense">
              <template v-slot:default>
                <tbody>
                  <tr v-if="balancete.visita.cliente">
                    <td v-text="`Cliente`" />
                    <td v-text="balancete.visita.cliente.nome" />
                  </tr>
                  <tr v-if="balancete.visita.tecnico">
                    <td v-text="`Técnico responsável`" />
                    <td v-text="balancete.visita.tecnico.nome" />
                  </tr>
                  <tr>
                    <td v-text="`Data da visita`" />
                    <td v-text="$options.filters.date(balancete.visita.data_visita)" />
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col cols="6">
            <v-simple-table :dense="tableDense">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      class="text-left subtitle-1 font-weight-bold accent--text"
                      v-text="`Dados do rebanho de lactação`"
                    />
                    <th
                      class="text-center"
                      v-text="`Valor`"
                    />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-text="`Total vacas em lactação`" />
                    <td
                      class="text-center"
                      v-text="`${balancete.vacas_total_lactacao} vacas`"
                    />
                  </tr>
                  <tr>
                    <td v-text="`${balancete.vacas_inicio_lactacao} vacas em início de lactação`" />
                    <td class="text-center">
                      {{ porcentagem(balancete.vacas_inicio_lactacao, balancete.vacas_total_lactacao) | percentage }}
                    </td>
                  </tr>
                  <tr>
                    <td v-text="`${balancete.vacas_meio_lactacao} vacas em meio de lactação`" />
                    <td class="text-center">
                      {{ porcentagem(balancete.vacas_meio_lactacao, balancete.vacas_total_lactacao) | percentage }}
                    </td>
                  </tr>
                  <tr>
                    <td v-text="`${balancete.vacas_fim_lactacao}  vacas em fim de lactação`" />
                    <td class="text-center">
                      {{ porcentagem(balancete.vacas_fim_lactacao, balancete.vacas_total_lactacao) | percentage }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-simple-table
              :dense="tableDense"
              class="mt-4"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      class="text-left subtitle-1 font-weight-bold accent--text"
                      v-text="`Custo das rações`"
                    />
                    <th
                      class="text-center"
                      v-text="`Valor`"
                    />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-text="`Ração concentrada`" />
                    <td class="text-center">
                      {{ balancete.custo_racao_concentrada | currency }}/Kg
                    </td>
                  </tr>
                  <tr>
                    <td v-text="`Ração volumosa`" />
                    <td class="text-center">
                      {{ balancete.custo_racao_volumosa | currency }}/Kg
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="font-weight-bold"
                      v-text="`Ração total`"
                    />
                    <td class="text-center">
                      {{ balancete.custo_racao_total | currency }}/Kg
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col cols="6">
            <v-simple-table
              :dense="tableDense"
              class="mt-4"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      class="text-left subtitle-1 font-weight-bold accent--text"
                      v-text="`Qualidade da RTM`"
                    />
                    <th
                      class="text-center"
                      v-text="`Valor`"
                    />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-text="`PB`" />
                    <td
                      class="text-center"
                      v-text="`${balancete.qualidade_rtm_pb}%`"
                    />
                  </tr>
                  <tr>
                    <td v-text="`NDT`" />
                    <td
                      class="text-center"
                      v-text="`${balancete.qualidade_rtm_ndt}%`"
                    />
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-simple-table
              :dense="tableDense"
              class="mt-4"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      class="text-left subtitle-1 font-weight-bold accent--text"
                      v-text="`Custo da alimentação/litro`"
                    />
                    <th
                      class="text-center"
                      v-text="`Valor`"
                    />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-text="`Custo`" />
                    <td class="text-center">
                      {{ balancete.custo_alimentacao_litro | currency }}/L
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-simple-table
              :dense="tableDense"
              class="mt-4"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      class="text-left subtitle-1 font-weight-bold accent--text"
                      v-text="`Receita com leite`"
                    />
                    <th
                      class="text-center"
                      v-text="`Valor`"
                    />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-text="`Produção média de leite`" />
                    <td
                      class="text-center"
                      v-text="`${$options.filters.decimal(balancete.producao_media_leite)} L/Vaca/Dia`"
                    />
                  </tr>
                  <tr>
                    <td v-text="`Produção total estimada do dia`" />
                    <td
                      class="text-center"
                      v-text="`${$options.filters.decimal(balancete.producao_estimada_dia)} litros`"
                    />
                  </tr>
                  <tr>
                    <td v-text="`Produção total estimada do mês`" />
                    <td
                      class="text-center"
                      v-text="`${$options.filters.decimal(balancete.producao_estimada_mes)} litros`"
                    />
                  </tr>
                  <tr>
                    <td v-text="`Consumo mensal da familia (estimado)`" />
                    <td
                      class="text-center"
                      v-text="`${$options.filters.decimal(balancete.consumo_mensal_familia_estimado)} litros`"
                    />
                  </tr>
                  <tr>
                    <td v-text="`Consumo mensal das bezerras (estimado)`" />
                    <td
                      class="text-center"
                      v-text="`${$options.filters.decimal(balancete.consumo_mensal_bezerras_estimado)} litros`"
                    />
                  </tr>
                  <tr>
                    <td v-text="`Quantidade de leite disponível para venda no mês`" />
                    <td
                      class="text-center"
                      v-text="`${$options.filters.decimal(balancete.quantidade_disponivel_venda)} litros`"
                    />
                  </tr>
                  <tr>
                    <td v-text="`Valor pago no leite`" />
                    <td
                      class="text-center"
                      v-text="$options.filters.currency(balancete.valor_pago_leite)"
                    />
                  </tr>
                  <tr>
                    <td
                      class="font-weight-bold"
                      v-text="`Receita bruta no dia`"
                    />
                    <td class="font-weight-bold text-center">
                      {{ balancete.receita_bruta_dia | currency }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="font-weight-bold"
                      v-text="`Receita bruta no mês`"
                    />
                    <td class="font-weight-bold text-center">
                      {{ balancete.receita_bruta_mes | currency }}
                    </td>
                  </tr>
                  <tr>
                    <td v-text="`Receita bruta + leite das bezerras`" />
                    <td class="text-center">
                      {{ balancete.receita_bruta_mes_leite | currency }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-simple-table
              :dense="tableDense"
              class="mt-4"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      class="text-left subtitle-1 font-weight-bold accent--text"
                      v-text="`Dados das vacas em lactação`"
                    />
                    <th
                      class="text-center"
                      v-text="`Valor`"
                    />
                    <th
                      class="text-center"
                      v-text="`Relação com a receita do leite`"
                    />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-text="`Custo da alimentação concentrada`" />
                    <td class="text-center">
                      {{ balancete.lactacao_custo_alimentacao_concentrada | currency }}
                    </td>
                    <td class="text-center">
                      {{ porcentagem(balancete.lactacao_custo_alimentacao_concentrada, balancete.receita_bruta_mes_leite) | percentage }}
                    </td>
                  </tr>
                  <tr>
                    <td v-text="`Custo da alimentação volumosa`" />
                    <td class="text-center">
                      {{ balancete.lactacao_custo_alimentacao_volumosa | currency }}
                    </td>
                    <td class="text-center">
                      {{ porcentagem(balancete.lactacao_custo_alimentacao_volumosa, balancete.receita_bruta_mes_leite) | percentage }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="font-weight-bold"
                      v-text="`Custo da alimentação da vacas em lactação`"
                    />
                    <td class="text-center font-weight-bold">
                      {{ balancete.lactacao_total_alimentacao | currency }}
                    </td>
                    <td
                      class="text-center font-weight-bold"
                    >
                      {{ porcentagem(balancete.lactacao_total_alimentacao, balancete.receita_bruta_mes_leite) | percentage }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-simple-table
              :dense="tableDense"
              class="mt-4"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      class="text-left subtitle-1 font-weight-bold accent--text"
                      v-text="`Alimentação das vacas no pré parto`"
                    />
                    <th
                      class="text-center"
                      v-text="`Valor`"
                    />
                    <th
                      class="text-center"
                      v-text="`Relação com a receita do leite`"
                    />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-text="`Custo da alimentação concentrada`" />
                    <td class="text-center">
                      {{ balancete.pre_parto_custo_alimentacao_concentrada | currency }}
                    </td>
                    <td class="text-center">
                      {{ porcentagem(balancete.pre_parto_custo_alimentacao_concentrada, balancete.receita_bruta_mes_leite) | percentage }}
                    </td>
                  </tr>
                  <tr>
                    <td v-text="`Custo da alimentação volumosa`" />
                    <td class="text-center">
                      {{ balancete.pre_parto_custo_alimentacao_volumosa | currency }}
                    </td>
                    <td class="text-center">
                      {{ porcentagem(balancete.pre_parto_custo_alimentacao_volumosa, balancete.receita_bruta_mes_leite) | percentage }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      class="font-weight-bold"
                      v-text="`Custo da alimentação da vacas no pré parto`"
                    />
                    <td
                      class="text-center font-weight-bold"
                    >
                      {{ balancete.pre_parto_total_alimentacao | currency }}
                    </td>
                    <td
                      class="text-center font-weight-bold"
                    >
                      {{ porcentagem(balancete.pre_parto_total_alimentacao, balancete.receita_bruta_mes_leite) | percentage }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-simple-table
          :dense="tableDense"
          class="mt-4"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  class="text-left subtitle-1 font-weight-bold accent--text"
                  v-text="`Alimentação das bezerras e novilhas`"
                />
                <th
                  class="text-center"
                  v-text="`Valor`"
                />
                <th
                  class="text-center"
                  v-text="`Relação com a receita do leite`"
                />
              </tr>
            </thead>
            <tbody>
              <tr>
                <td v-text="`Custo do leite das bezerras`" />
                <td class="text-center">
                  {{ balancete.bezerras_custo_leite | currency }}
                </td>
                <td class="text-center">
                  {{ porcentagem(balancete.bezerras_custo_leite, balancete.receita_bruta_mes_leite) | percentage }}
                </td>
              </tr>
              <tr>
                <td v-text="`Custo da alimentação concentrada`" />
                <td class="text-center">
                  {{ balancete.bezerras_custo_alimentacao_concentrada | currency }}
                </td>
                <td class="text-center">
                  {{ porcentagem(balancete.bezerras_custo_alimentacao_concentrada, balancete.receita_bruta_mes_leite) | percentage }}
                </td>
              </tr>
              <tr>
                <td v-text="`Custo da alimentação volumosa`" />
                <td class="text-center">
                  {{ balancete.bezerras_custo_alimentacao_volumosa | currency }}
                </td>
                <td class="text-center">
                  {{ porcentagem(balancete.bezerras_custo_alimentacao_volumosa, balancete.receita_bruta_mes_leite) | percentage }}
                </td>
              </tr>
              <tr>
                <td
                  class="font-weight-bold"
                  v-text="`Custo da alimentação de bezerras e novilhas`"
                />
                <td class="text-center font-weight-bold">
                  {{ balancete.bezerras_total_alimentacao | currency }}
                </td>
                <td
                  class="text-center font-weight-bold"
                >
                  {{ porcentagem(balancete.bezerras_total_alimentacao, balancete.receita_bruta_mes_leite) | percentage }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table
          :dense="tableDense"
          class="mt-4"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  class="text-left subtitle-1 font-weight-bold accent--text"
                  v-text="`Alimentação do rebanho`"
                />
                <th
                  class="text-center"
                  v-text="`Valor`"
                />
                <th
                  class="text-center"
                  v-text="`Relação com a receita do leite`"
                />
              </tr>
            </thead>
            <tbody>
              <tr>
                <td v-text="`Custo do leite das bezerras`" />
                <td class="text-center">
                  {{ balancete.rebanho_custo_leite | currency }}
                </td>
                <td class="text-center">
                  {{ porcentagem(balancete.rebanho_custo_leite, balancete.receita_bruta_mes_leite) | percentage }}
                </td>
              </tr>
              <tr>
                <td v-text="`Custo da alimentação concentrada`" />
                <td class="text-center">
                  {{ balancete.rebanho_custo_alimentacao_concentrada | currency }}
                </td>
                <td class="text-center">
                  {{ porcentagem(balancete.rebanho_custo_alimentacao_concentrada, balancete.receita_bruta_mes_leite) | percentage }}
                </td>
              </tr>
              <tr>
                <td v-text="`Custo da alimentação volumosa`" />
                <td class="text-center">
                  {{ balancete.rebanho_custo_alimentacao_volumosa | currency }}
                </td>
                <td class="text-center">
                  {{ porcentagem(balancete.rebanho_custo_alimentacao_volumosa, balancete.receita_bruta_mes_leite) | percentage }}
                </td>
              </tr>
              <tr>
                <td
                  class="font-weight-bold"
                  v-text="`Custo estimato da alimentação do rebanho`"
                />
                <td class="text-center font-weight-bold">
                  {{ balancete.rebanho_custo_alimentacao | currency }}
                </td>
                <td
                  class="text-center font-weight-bold"
                >
                  {{ porcentagem(balancete.rebanho_custo_alimentacao, balancete.receita_bruta_mes_leite) | percentage }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table
          :dense="tableDense"
          class="mt-4"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  class="text-left subtitle-1 font-weight-bold accent--text"
                  v-text="`Custo da suplementacao mineral`"
                />
                <th
                  class="text-center"
                  v-text="`Valor`"
                />
                <th
                  class="text-center"
                  v-text="`Relação com a receita do leite`"
                />
              </tr>
            </thead>
            <tbody>
              <tr>
                <td v-text="`Alimentação das vacas em lactação`" />
                <td class="text-center">
                  {{ balancete.vacas_lactacao_custo_mineral | currency }}
                </td>
                <td class="text-center">
                  {{ porcentagem(balancete.vacas_lactacao_custo_mineral, balancete.receita_bruta_mes_leite) | percentage }}
                </td>
              </tr>
              <tr>
                <td v-text="`Alimentação das vacas secas e no pré parto`" />
                <td class="text-center">
                  {{ balancete.pre_parto_custo_mineral | currency }}
                </td>
                <td class="text-center">
                  {{ porcentagem(balancete.pre_parto_custo_mineral, balancete.receita_bruta_mes_leite) | percentage }}
                </td>
              </tr>
              <tr>
                <td v-text="`Alimentação das bezerras e novilhas`" />
                <td class="text-center">
                  {{ balancete.bezerras_custo_mineral | currency }}
                </td>
                <td class="text-center">
                  {{ porcentagem(balancete.bezerras_custo_mineral, balancete.receita_bruta_mes_leite) | percentage }}
                </td>
              </tr>
              <tr>
                <td
                  class="font-weight-bold"
                  v-text="`Custo estimado da mineralização do rebanho`"
                />
                <td class="text-center font-weight-bold">
                  {{ balancete.total_custo_mineral | currency }}
                </td>
                <td
                  class="text-center font-weight-bold"
                >
                  {{ porcentagem(balancete.total_custo_mineral, balancete.receita_bruta_mes_leite) | percentage }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table
          :dense="tableDense"
          class="mt-4"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  class="text-left subtitle-1 font-weight-bold accent--text"
                  v-text="`Sobras (com relação à alimentação)`"
                />
                <th
                  class="text-center"
                  v-text="`Valor`"
                />
                <th
                  class="text-center"
                  v-text="`Relação com a receita do leite`"
                />
              </tr>
            </thead>
            <tbody>
              <tr>
                <td v-text="`Custo estimado com leite + leite bezerras`" />
                <td class="text-center">
                  {{ balancete.sobra_receita_estimada | currency }}
                </td>
                <td class="text-center">
                  -
                </td>
              </tr>
              <tr>
                <td v-text="`Despesas estimadas com alimentação`" />
                <td class="text-center">
                  {{ balancete.sobra_despesa_estimada | currency }}
                </td>
                <td class="text-center">
                  {{ porcentagem(balancete.sobra_despesa_estimada, balancete.receita_bruta_mes_leite) | percentage }}
                </td>
              </tr>
              <tr>
                <td
                  class="font-weight-bold"
                  v-text="`Sobra estimada`"
                />
                <td class="text-center font-weight-bold">
                  {{ balancete.sobra_total_estimada | currency }}
                </td>
                <td
                  class="text-center font-weight-bold"
                >
                  {{ porcentagem(balancete.sobra_total_estimada, balancete.receita_bruta_mes_leite) | percentage }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </app-widget>
  </app-report>
</template>

<script>
import { mapGetters } from 'vuex'
import AppWidget from '@/components/AppWidget'
import AppReport from '@/components/layouts/AppReport'
export default {
  name: 'CidadesCreate',
  components: {
    AppWidget,
    AppReport
  },
  computed: {
    ...mapGetters(['balancete', 'tableDense'])
  },
  methods: {
    porcentagem (indice, total) {
      return indice / total
    }
  },
  mounted () {
    console.table(this.balancete)
  }
}
</script>
